interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
  duration?: number;
}

export const useToast = () => {
  const toast = (options: ToastOptions) => {
    // Implémentation simple avec console.log pour l'instant
    const { title, description, variant = 'default' } = options;
    
    if (variant === 'destructive') {
      console.error(`❌ ${title}: ${description || ''}`);
    } else {
      console.log(`✅ ${title}: ${description || ''}`);
    }
    
    // Ici on pourrait implémenter une vraie notification toast
    // Pour l'instant, on utilise juste console.log
  };

  return { toast };
};
